import { editCustomerSchema } from '../schema/editCustomerSchema'
import { DateObject } from 'react-multi-date-picker'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'
import moment from 'moment-jalaali'
import { getData } from '../assets/scripts/GeneralFunctions'
import { errorList } from './stateList'
import { EditCustomersResponse } from './CustomersResponse'

export const userEditModalSubmit = async (
  setIsSubmit,
  inputs,
  customer,
  car,
  setCar,
  setShowModal,
  error,
  setError
) => {
  try {
    const value = await editCustomerSchema.validate(inputs, { abortEarly: false })

    const date = new DateObject({
      date: value?.birth_date,
      calendar: persian,
      locale: persian_fa,
    })

    const birthDate = moment(
      `${date.getValue('YYYY')}-${date.getValue('MM')}-${date.getValue('DD')}`,
      'jYYYY-jMM-jDD'
    ).format('YYYY-MM-DD')

    const obj = {
      ...value,
      birth_date: value?.birth_date && date.getValue('YYYY') ? birthDate : '',
    }

    const apiResult = await getData(`admin/customers/update/${customer?.id}`, 'post', obj, true)

    setIsSubmit(false)

    if (apiResult?.status === 200) {
      setCar({
        ...car,
        customer: apiResult?.data?.customer,
      })
      setShowModal(false)
    } else {
      setError(apiResult)
    }
  } catch (err) {
    setIsSubmit(false)
    setError({
      ...error,
      ...errorList(err),
    })
  }
}

export const userMainEditModalSubmit = async (
  setIsSubmit,
  inputs,
  customer,
  setShowModal,
  error,
  setError,
  customers,
  customer_types,
  setCustomerTypeListItem,
  setCustomers
) => {
  try {
    const validatedInputs = await editCustomerSchema.validate(inputs, { abortEarly: false })
    const birthDate = new DateObject({
      date: validatedInputs?.birth_date,
      calendar: persian,
      locale: persian_fa,
    })

    const api_result = await getData(
      `admin/customers/update/${customer?.id}`,
      'post',
      {
        ...validatedInputs,
        birth_date:
          validatedInputs?.birth_date && birthDate.getValue('YYYY')
            ? moment(
                `${birthDate.getValue('YYYY')}-${birthDate.getValue('MM')}-${birthDate.getValue(
                  'DD'
                )}`,
                'jYYYY-jMM-jDD'
              ).format('YYYY-MM-DD')
            : '',
      },
      true
    )

    if (api_result) {
      setIsSubmit(false)
      if (api_result?.status === 200) {
        EditCustomersResponse(
          api_result?.data?.customer,
          customers,
          customer_types,
          setCustomerTypeListItem,
          setCustomers,
          setShowModal
        )
      }
    }
  } catch (err) {
    setIsSubmit(false)
    setError({ ...error, ...errorList(err) })
  }
}
